import { render } from "./event_register.vue?vue&type=template&id=28a8b177&scoped=true"
import script from "./event_register.vue?vue&type=script&lang=js"
export * from "./event_register.vue?vue&type=script&lang=js"

import "./event_register.vue?vue&type=style&index=0&id=28a8b177&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28a8b177"]])

export default __exports__